export var cleanPhone = function cleanPhone(phone) {
  return phone.replace(/^\+7|[^\d]/g, '');
};